import adminRequest from '../../../config/adminRequest';
import { UsdtUri } from '../../core/configs/services';
import { AdminResponse } from '../models/adminResponse';

export type GlobalSetting = {
  CUSTOM_EXCHANGE_RATE: boolean;
  CNY_TO_USDT_SELL_PRICE: number;
  CNY_TO_USDT_BUY_PRICE: number;
  ETH_TO_USDT_RATE?: number;
  TRANSFER_THRESHOLD_RATE: number;
  TRX_TO_USDT_RATE?: number;
  SOL_TO_USDT_RATE?: number;
  AGENTFUNDING_ETH_FEE?: number;
  AGENTFUNDING_TRX_FEE?: number;
  AGENTFUNDING_SOL_FEE?: number;
  AGENTFUNDING_BNB_FEE?: number;
  PAYOUT_ENERGY_METHOD?: string;
  PAYOUT_HALTED?: boolean;
  COLLECT_ENERGY_THRESHOLD?: number;
  COLLECT_C_ENABLED?: boolean;
  COLLECT_E_ENABLED?: boolean;
  COLLECT_C_MIN_TRX?: number;
  COLLECT_USER_USDT_MIN?: number;
  COLLECT_MCH_USDT_MIN?: number;
  COLLECT_E_MIN_ENERGY?: number;
  E_CONFIRM_TIMEOUT_SEC?: number;
  COLLECT_C_BANDWIDTH_ENABLED?: boolean;
  PAYOUT_C2_ENABLED?: boolean;
  C2_RECEIVER?: string;
  C2_AMOUNT?: number;
  PAYOUT_D_ENABLED?: boolean;
  PAYOUT_TRX_TOPUP_BELOW?: number;
  PAYOUT_TRX_TOPUP_AMOUNT?: number;
  RENTAL_TRX_KEEP_MIN?: number;
  FILL_TRX_AMOUNT?: number;
  C_ROTATION_AMOUNTS?: string;
  C_ROTATION_RECEIVERS?: string;
  /** 出款專用 C 輪替金額;留空 = 沿用 C_ROTATION_AMOUNTS(歸集/共用)。 */
  PAYOUT_C_ROTATION_AMOUNTS?: string;
  /** 出款專用 C 輪替收款地址;留空 = 沿用 C_ROTATION_RECEIVERS(歸集/共用)。 */
  PAYOUT_C_ROTATION_RECEIVERS?: string;
  /** 出款 C 挑 receiver:random(預設)/round_robin(Redis 游標順序輪)。 */
  PAYOUT_C_PICK_MODE?: string;
  C_CONFIRM_TIMEOUT_SEC?: number;
  TRONIFY_ADDRESS?: string;
  TRONIFY_SOURCE?: string;
  TRONIFY_API_KEY?: string;
  TG_ALERT_CHATID?: string;
  TG_ALERT_TOKEN?: string;
  COLLECT_DEST_STRATEGY?: string;
  COLLECT_DEST_THRESHOLD?: number;
  PAYOUT_WALLET_MAX_BALANCE?: number;
  PAYFOR_FAIL_CALLBACK?: string;
  PAYFOR_FAIL_TG_CHATID?: string;
  PAYOUT_FAIL_TG_CHATID?: string;
  D_RENTAL_ADDRESS?: string;
  D_RENTAL_TRX_LOW?: string | number;
  D_RENTAL_TRX_HIGH?: string | number;
  D_CONFIRM_TIMEOUT_SEC?: string | number;
  PAYOUT_TRX_MIN_ALERT?: string | number;
  PAYOUT_TRX_MIN_DISABLE?: string | number;
  PAYOUT_MAX_BURN_TRX?: string | number;
  PAYOUT_UNDELEGATE_DELAY_SEC?: string | number;
  PAYOUT_SWEEP_IDLE_MIN?: string | number;
  RENTAL_BANDWIDTH_MIN?: string | number;
  C_SEND_BANDWIDTH_ENABLED?: boolean;
  /** 出款 C 借帶寬走「等上塊」確認的灰度比例(0~1)。0=全走舊輪詢、1=全量。 */
  C_BW_WAIT_BLOCK_RATIO?: string | number;
  C_RECLAIM_BANDWIDTH_ENABLED?: boolean;
  /** 一次性 TRX 回收工具的門檻,空值 = 停用整支工具。 */
  TRX_SWEEP_MIN?: string | number;
  /** F2 棄用錢包歸集/清空 的目的地。只能設成白名單內地址(RENTAL/老闆)。 */
  RETIRE_SWEEP_DEST?: string;
  /** F1 一次性 TRX 回收 的目的地。未設時後端 fallback 到 RETIRE_SWEEP_DEST。 */
  TRX_SWEEP_DEST?: string;
};

/** 回收目的地白名單的一個選項。 */
export type SweepDestOption = { address: string; label: string };

export class GlobalSettingProvider {
  static async get() {
    const res = await adminRequest.get<AdminResponse<GlobalSetting>>(
      UsdtUri(`/admin/global-setting`),
    );
    return res.data;
  }

  static async put(data: Partial<GlobalSetting>) {
    const res = await adminRequest.put<AdminResponse<GlobalSetting>>(
      UsdtUri(`/admin/global-setting`),
      data,
    );
    return res.data;
  }

  /** 回收目的地下拉選項(白名單) —— TRX 回收 / 棄用歸集 只能選這裡面的地址。 */
  static async getSweepDestOptions() {
    const res = await adminRequest.get<AdminResponse<SweepDestOption[]>>(
      UsdtUri(`/admin/global-setting/sweep-dest-options`),
    );
    return res.data;
  }
}
